export default __webpack_public_path__ + "static/media/ring.e572cc9e.svg";